// @flow
import type { Untranslated } from '@rover/shared/js/types';

export default class APIError extends Error {
  status: number;

  constructor(message: Untranslated, status: number) {
    super(message.id || message);
    this.status = status;
  }
}



// WEBPACK FOOTER //
// ../react-lib/src/apis/APIError.js